/**
 * Convert a number to Arabic words for Lebanese Lira
 * e.g., 876273 -> "ثمانمئة وستة وسبعون ألفاً ومئتان وثلاثة وسبعون ليرة لبنانية"
 */

const ones = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة', 'عشرة',
  'أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر', 'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر'];

const tens = ['', '', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];

const hundreds = ['', 'مئة', 'مئتان', 'ثلاثمئة', 'أربعمئة', 'خمسمئة', 'ستمئة', 'سبعمئة', 'ثمانمئة', 'تسعمئة'];

function convertGroup(n) {
  if (n === 0) return '';
  if (n < 20) return ones[n];
  if (n < 100) {
    const t = Math.floor(n / 10);
    const o = n % 10;
    if (o === 0) return tens[t];
    return ones[o] + ' و' + tens[t];
  }
  const h = Math.floor(n / 100);
  const remainder = n % 100;
  if (remainder === 0) return hundreds[h];
  return hundreds[h] + ' و' + convertGroup(remainder);
}

export function numberToArabicWords(num) {
  if (num === 0) return 'صفر ليرة لبنانية';

  num = Math.floor(Math.abs(num));

  if (num === 0) return 'صفر ليرة لبنانية';

  const parts = [];

  // Billions
  const billions = Math.floor(num / 1000000000);
  if (billions > 0) {
    if (billions === 1) parts.push('مليار');
    else if (billions === 2) parts.push('ملياران');
    else parts.push(convertGroup(billions) + ' مليارات');
    num %= 1000000000;
  }

  // Millions
  const millions = Math.floor(num / 1000000);
  if (millions > 0) {
    if (millions === 1) parts.push('مليون');
    else if (millions === 2) parts.push('مليونان');
    else if (millions <= 10) parts.push(convertGroup(millions) + ' ملايين');
    else parts.push(convertGroup(millions) + ' مليون');
    num %= 1000000;
  }

  // Thousands
  const thousands = Math.floor(num / 1000);
  if (thousands > 0) {
    if (thousands === 1) parts.push('ألف');
    else if (thousands === 2) parts.push('ألفان');
    else if (thousands <= 10) parts.push(convertGroup(thousands) + ' آلاف');
    else parts.push(convertGroup(thousands) + ' ألفاً');
    num %= 1000;
  }

  // Remainder (hundreds, tens, ones)
  if (num > 0) {
    parts.push(convertGroup(num));
  }

  return parts.join(' و') + ' ليرة لبنانية';
}
